var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 19c-.5 0-.9-.2-1.1-.5L.4 11.3c-.5-.6-.5-1.6.2-2.1.6-.5 1.6-.5 2.1.2l5 5.8L19.5 1.5c.5-.6 1.5-.7 2.1-.2.6.5.7 1.5.2 2.1l-13 15c-.3.4-.7.6-1.1.6z"
  })));
}

export default SvgCheckmark;